<script setup lang='ts'>
import { numFormat } from '@qctsw/utils'
import { APP_ROUTER } from '@qctsw/common'
import { logicReputationSeriesRank } from '@/logic/reputation/rank'

const {
  state,
  data,
  getData,
} = logicReputationSeriesRank()

await getData()
</script>

<template>
  <div>
    <UtilLoadState :state="state" :reload-handler="getData">
      <div v-if="data" class="grid grid-cols-3 gap-12">
        <table class="rank-container from-red-2 to-slate-1">
          <caption>
            <BasicTitle size="20" title="完成率" text-center :left-border="false" />
          </caption>
          <thead class="block">
            <tr class="rank-header bg-red-4">
              <th v-for="(v, i) in ['排行', '名称', '百分比(%)']" :key="i">
                {{ v }}
              </th>
            </tr>
          </thead>
          <tbody class="rank-item__list">
            <tr
              v-for="(v, i) in data[0]" :key="i"
              class="rank-item"
            >
              <td>{{ i + 1 }}</td>
              <td>
                <NEllipsis>
                  <NuxtLink :to="APP_ROUTER.reputationDetail(v.carSeriesId)" class="hover:text-red-5">
                    {{ v.carBrandName }} - {{ v.carSeriesName }}
                  </NuxtLink>
                </NEllipsis>
              </td>
              <td>{{ v.value }}</td>
            </tr>
          </tbody>
        </table>
        <table class="rank-container from-green-2 to-slate-1">
          <caption>
            <BasicTitle size="20" title="回复率" :left-border="false" />
          </caption>
          <thead class="block">
            <tr class="rank-header bg-emerald-4">
              <th v-for="(v, i) in ['排行', '名称', '百分比(%)']" :key="i">
                {{ v }}
              </th>
            </tr>
          </thead>
          <tbody class="rank-item__list">
            <tr v-for="(v, i) in data[1]" :key="i" class="rank-item">
              <td>{{ i + 1 }}</td>
              <td>
                <NEllipsis>
                  <NuxtLink :to="APP_ROUTER.reputationDetail(v.carSeriesId)" class="hover:text-emerald-5">
                    {{ v.carBrandName }} - {{ v.carSeriesName }}
                  </NuxtLink>
                </NEllipsis>
              </td>
              <td>{{ v.value }}</td>
            </tr>
          </tbody>
        </table>
        <table class="rank-container from-blue-3 to-slate-1">
          <caption>
            <BasicTitle size="20" title="投诉量" :left-border="false" />
          </caption>
          <thead class="block">
            <tr class="rank-header bg-blue-5 ">
              <th v-for="(v, i) in ['排行', '名称', '投诉量']" :key="i">
                {{ v }}
              </th>
            </tr>
          </thead>
          <tbody class="rank-item__list">
            <tr v-for="(v, i) in data[2]" :key="i" class="rank-item">
              <td>
                {{ i + 1 }}
              </td>
              <td>
                <NEllipsis>
                  <NuxtLink :to="APP_ROUTER.reputationDetail(v.carSeriesId)" class="hover:text-blue-5">
                    {{ v.carBrandName }} - {{ v.carSeriesName }}
                  </NuxtLink>
                </NEllipsis>
              </td>
              <td>{{ v.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <BasicEmpty v-else />
    </UtilLoadState>
  </div>
</template>

<style lang='scss' scoped>
.rank-container {
  --uno: block p-sm rounded-md bg-gradient-to-br shadow;
}

.rank-header {
  --uno: text-4 font-bold rounded-md text-white px-sm py-2 block w-full;
  --uno: flex items-center mt-sm;
  &>*:nth-child(1) {
    --uno: mr-sm flex-shrink-0;
  }

  &>*:nth-child(2) {
    --uno: flex-grow overflow-hidden text-left;
  }

  &>*:nth-child(3) {
    --uno: flex-shrink-0 ml-4;
  }
}

.rank-item {
  --uno: flex items-center mt-3 px-3;

  &__list{
    --uno: w-full block;
  }

  &>td:first-child {
    --uno: grid place-items-center italic font-black w-6 h-6 rounded-full select-none flex-shrink-0;
    --uno: bg-gradient-to-tl from-gray-300 to-white text-3.25 text-gray-400 mr-sm;
  }

  &:nth-child(-n + 3) {
    &>td:first-child {
      --uno: from-yellow-3 to-white text-red-6;
    }
  }
  &:nth-child(1) {
    &>td:first-child {
    --uno: text-red-6;
    }
  }
  &:nth-child(2) {
    &>td:first-child {
    --uno: text-red-4;
    }
  }
  &:nth-child(3) {
    &>td:first-child {
    --uno: text-yellow-5;
    }
  }

  &>td:nth-child(2) {
    --uno: flex-1 truncate text-4 text-left;
  }

  &>td:nth-child(3) {
    --uno: flex-shrink-0 ml-4 font-mono text-1.1em;
  }
}
</style>
